import styled from 'styled-components'
import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'

import Select from 'builder/components/Select'
import { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const Label = styled.p`
  flex: 0.5;
  color: ${Colors.Neutral90};
  ${Typography.sizes.Caption};
  ${FontWeights.Regular};
`

export const SelectContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${Spacing['3XS']};
  width: 100%;
`

export const SelectLabel = styled.p`
  color: ${Colors.Neutral50};
  ${Typography.sizes.Caption};
  ${FontWeights.Regular};
`

export const CustomSelect = styled(Select)`
  width: 100%;
  margin-bottom: unset;
  border-radius: 4px;

  button {
    svg {
      fill: ${Colors.Neutral50};
    }

    &:hover {
      svg {
        fill: ${Colors.Blue50};
      }
    }
  }
`
